/* eslint-disable camelcase */
import { useState } from 'react';
import { useRouter } from 'next/router';
import { CashSession, CashSessionStatus } from '@/@types/cash-management';
import { getTodayDateAsString } from '@/utils/date';

export function useCashSessionsFilters() {
  const router = useRouter();

  const {
    search = '',
    status = '',
    opened_at_start = '',
    opened_at_end = '',
    sort = 'desc',
    sort_by = 'created_at',
    page = 1,
    per_page = 25,
  } = router.query;

  const today = getTodayDateAsString();

  const [tempSearch, setTempSearch] = useState(search || '');
  const [tempStatus, setTempStatus] = useState(status || '');
  const [tempStartDate, setTempStartDate] = useState(opened_at_start || today);
  const [tempEndDate, setTempEndDate] = useState(opened_at_end || today);

  const handleFilter = () => {
    router.replace({
      query: {
        page: 1,
        search: tempSearch,
        status: tempStatus,
        opened_at_start: tempStartDate,
        opened_at_end: tempEndDate,
        sort,
        sort_by,
        per_page,
      },
    });
  };

  const handleClearFilters = () => {
    router.replace('/cash_sessions');
    setTempSearch('');
    setTempStatus('');
    setTempStartDate(today);
    setTempEndDate(today);
  };

  const handlePageChange = (newPage: number) => {
    router.replace({
      query: {
        ...router.query,
        page: newPage + 1,
      },
    });
  };

  const handlePerPageChange = (newPerPage: number) => {
    router.replace({
      query: {
        ...router.query,
        per_page: newPerPage,
      },
    });
  };

  const handleSort = (column: string) => {
    router.replace({
      query: {
        ...router.query,
        sort: sort === 'asc' ? 'desc' : 'asc',
        sort_by: column,
      },
    });
  };

  return {
    search: search as string,
    status: status as CashSessionStatus | '',
    startDate: (opened_at_start as string | undefined) || today,
    endDate: (opened_at_end as string | undefined) || today,
    sort: sort as 'asc' | 'desc',
    sortBy: sort_by as keyof CashSession,
    page: Number(page),
    perPage: Number(per_page),
    tempSearch: tempSearch as string,
    setTempSearch,
    tempStatus: tempStatus as CashSessionStatus | '',
    setTempStatus,
    tempStartDate: tempStartDate as string,
    setTempStartDate,
    tempEndDate: tempEndDate as string,
    setTempEndDate,
    handleFilter,
    handleClearFilters,
    handlePageChange,
    handlePerPageChange,
    handleSort,
  };
}
